<template>
  <!-- 网上商城 -->
  <div id="onlineMall">
    <div v-if="userId || wxgenerateid">
      <template v-if="mallver != 'v1'">
        <newOnlineMall
          ref="newOmlineMallComponent"
          :goodsLists="goodsLists"
          :routerAgentCode="routerAgentCode"
          :titleNameWord="titleNameWord"
        ></newOnlineMall>
      </template>
      <template v-else-if="mallver == 'v1'">
        <div style="height: 10px; background-color: #f7f7f7"></div>
        <van-tabs
          v-model="active"
          :line-width="0"
          :line-height="0"
          @click="changeVanTabs"
          @disabled="clickDisabledTab"
        >
          <van-tab title="账号等级" :disabled="accounttype == 3">
            <div class="shopBox">
              <acount-level
                @changeVanTabs="changeVanTabs"
                :titleNameWord="titleNameWord"
              ></acount-level>
            </div>
          </van-tab>
          <van-tab title="VIP升级权限" :disabled="vipDisabled">
            <div class="shopBox">
              <h3 style="text-align: center">{{ titleNameWord }}</h3>
              <van-divider
                :style="{
                  fontSize: '17px',
                  marginTop: '20px',
                  marginBottom: '20px',
                }"
              >
                选择账号等级包
              </van-divider>
              <div
                style="margin-bottom: 20px"
                :class="effectiveorders.length > 3 ? 'overthree' : ''"
              >
                <van-radio-group
                  v-model="productcodeMenuOrderId"
                  @change="choseMenu"
                >
                  <van-radio
                    v-for="item in effectiveorders"
                    :name="item.orderid"
                    :key="item.orderid"
                    style="margin-bottom: 10px"
                  >
                    {{ item.productname }}
                    ({{ moment(item.starttime).format("YYYY-MM-DD") }} 至
                    {{ moment(item.endtime).format("YYYY-MM-DD") }})
                  </van-radio>
                </van-radio-group>
              </div>
              <van-divider
                :style="{
                  fontSize: '17px',
                  marginTop: '10px',
                  marginBottom: '30px',
                }"
              >
                您可选择下列升级服务
              </van-divider>
              <van-grid
                :column-num="2"
                :gutter="10"
                style="position: relative; z-index: 1"
              >
                <van-grid-item
                  @click="clickUpgrade(item)"
                  v-for="(item, index) in gridItems"
                  :key="index"
                >
                  <van-icon
                    name="success"
                    class="successIcon"
                    v-if="item.alreadybought === item.maxactive"
                  />
                  <van-image
                    v-if="item.funccode === '000009'"
                    class="vipImg"
                    :src="img11"
                  />
                  <van-image
                    v-if="item.funccode === '000010'"
                    class="vipImg"
                    :src="img44"
                  />
                  <van-image
                    v-if="item.funccode === '000011'"
                    class="vipImg"
                    :src="img22"
                  />
                  <van-image
                    v-if="item.funccode === '000012'"
                    class="vipImg"
                    :src="img33"
                  />

                  <van-image
                    v-if="item.funccode === '000017'"
                    class="vipImg"
                    :src="img55"
                  />
                  <van-image
                    v-if="item.funccode === '000004'"
                    class="vipImg"
                    :src="img66"
                  />
                  <van-image
                    v-if="item.funccode === '000005'"
                    class="vipImg"
                    :src="img77"
                  />
                  <span style="margin-top: 6px; color: #5e5f5d">{{
                    item.funcname
                  }}</span>
                </van-grid-item>
              </van-grid>
            </div>
            <!-- 购物车 -->
            <van-goods-action
              v-if="accounttype == 1 || accounttype == 4"
              style="z-index: 100"
            >
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button
                type="danger"
                text="立即购买"
                @click="buyNow('all')"
              />
            </van-goods-action>
          </van-tab>
        </van-tabs>
        <!-- 购买版本 立即购买商品弹框 -->
        <van-popup
          v-model="show"
          @close="closePopup"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', background: '#FAF9FA' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '10px',
            }"
          >
            请确认您购买的产品
          </van-divider>
          <div class="shopBox">
            <div class="shop-item">
              <div class="item-top">
                <div class="money">
                  <div class="title">{{ buyItem.name }}</div>
                  <div>
                    <van-tag color="#FE504F" plain>{{ buyItem.desc }}</van-tag>
                  </div>
                </div>
              </div>
              <div class="chooseYear bottom-line">
                <div
                  class="one"
                  :class="{ yearActive: currentYearIndex === index }"
                  v-for="(year, index) in years"
                  :key="index"
                  @click="changeYear(year, index)"
                >
                  <p class="year">{{ year.salenumber }}年</p>
                  <p
                    style="color: #a17d59; font-size: 16px; margin: 18px 0"
                    class="year"
                  >
                    {{ year.discountname }}
                  </p>
                  <p>
                    <van-tag color="#A17D59">{{ year.discountdesc }}</van-tag>
                  </p>
                </div>
              </div>
              <div class="item-center">
                <div class="word">配置:</div>
                <div class="tag">
                  <van-tag
                    text-color="#727272"
                    color="#AAA6A6"
                    plain
                    v-for="(tag, index) in buyItem.BasePackageFun"
                    :key="index"
                    style="background-color: #f7f7f7"
                    >{{ tag.alias }}</van-tag
                  >
                </div>
              </div>
            </div>
            <div style="margin-top: 20px">
              <p style="font-size: 14px; color: #656565; margin-bottom: 20px">
                优惠信息
              </p>
              <van-field
                v-if="isConpponma"
                v-model="coupon"
                center
                clearable
                label="优惠码"
                placeholder="请输入优惠码"
                @clear="clearCoupon"
                :disabled="checked ? true : false"
              >
              </van-field>
              <van-field
                v-model="locationAgentCode"
                v-if="locationAgentCode"
                center
                clearable
                label="运营商编码"
                placeholder="请输入运营商编码"
                @clear="clearCoupon"
                disabled
              >
              </van-field>
              <van-field
                v-model="agentCode"
                v-else
                center
                clearable
                label="运营商编码"
                placeholder="请输入运营商编码"
                @clear="clearCoupon"
                :disabled="checked ? true : false"
              >
              </van-field>
              <van-cell title=" ">
                <template #right-icon>
                  <span style="margin-right: 10px"
                    >确认使用{{ isConpponma ? "优惠码和" : "" }}运营商编码</span
                  >
                  <van-checkbox
                    :disabled="coupon || agentCode ? false : true"
                    @change="changeChecked"
                    v-model="checked"
                  />
                </template>
              </van-cell>
              <van-cell title=" ">
                <template #right-icon>
                  <span style="margin-right: 10px; color: green">{{
                    checked ? alertMessage_1 : ""
                  }}</span>
                </template>
              </van-cell>
            </div>
            <div style="margin-top: 20px" @click="drawABill">
              <van-cell title="发票" is-link :value="invoiceWord" />
            </div>
            <div class="payMethods">
              <p>请选择支付方式</p>
              <van-radio-group v-model="radioPay">
                <van-cell-group>
                  <van-cell clickable @click="radioPay = '1'">
                    <template #title>
                      <van-image width="30" height="30" :src="wxImg" />
                      <span class="custom-title">微信支付</span>
                    </template>
                    <template #right-icon>
                      <van-radio name="1" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
            <van-submit-bar
              :disabled="totalPrice > 0 ? false : true"
              :price="totalPrice"
              button-text="去支付"
              :loading="loadingFlag ? true : false"
              @submit="confirmPayment"
            >
            </van-submit-bar>
          </div>
        </van-popup>
        <!-- 购物车弹框 -->
        <van-popup
          v-model="openShopCar"
          @close="closePopup"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F7F7F7' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '10px',
            }"
          >
            购物车
          </van-divider>
          <div v-if="shopCarLists.length === 0">
            <van-empty image="search" description="暂无内容" />
          </div>
          <div v-else>
            <div class="upgradeItems">
              <!-- VIP套餐 -->
              <div
                class="top-box"
                v-for="(item, index) in shopCarLists"
                :key="index"
              >
                <div class="message">
                  <div class="left">
                    <p class="title">{{ item.funcname }}</p>
                    <p class="desc">
                      <van-tag plain color="#53514F" style="padding: 6px">{{
                        item.funcdesc
                      }}</van-tag>
                    </p>
                  </div>
                  <div class="price">
                    &yen;<span>{{
                      (item.price * vipItemBuyDay * item.num) | toDecimal
                    }}</span>
                  </div>
                  <van-icon
                    name="minus"
                    color="#d00"
                    style="
                    margin-left: 10px;
                    border-radius: 50%;
                    font-size: 16px;
                    border: 1px solid #d00;
                  "
                    @click="delItem(item, index)"
                  />
                </div>
                <div class="yearBox">
                  <div class="year">购买时长：{{ vipItemBuyDay }}天</div>
                  <div class="num">
                    <span
                      v-if="
                        item.funccode === '000009' || item.funccode === '000010'
                      "
                      >购买数量：1</span
                    >
                    <van-stepper
                      v-else
                      v-model.number="item.num"
                      integer
                      :min="1"
                      :max="item.maxactive - item.alreadybought"
                      style="margin: auto"
                      @change="inputChange"
                    />
                  </div>
                  <!-- :min="item.minctive" -->
                </div>
              </div>
              <div class="discountMsg">
                <p
                  style="
                  color: #656565;
                  margin-left: 20px;
                  margin-top: 20px;
                  margin-bottom: 20px;
                "
                >
                  优惠信息
                </p>
                <van-cell-group>
                  <van-cell
                    v-for="item in discountdescdetail"
                    :key="item.discountdesc"
                    :title="item.discountdesc"
                  >
                    <template #right-icon>
                      <span
                        v-if="item.selected === false"
                        style="padding-left: 12px"
                        >未满足</span
                      >
                      <van-radio
                        v-if="item.selected === true"
                        style="padding-left: 12px"
                      ></van-radio>
                    </template>
                  </van-cell>
                </van-cell-group>
              </div>
              <div style="margin-top: 20px" v-if="isConpponma">
                <van-field
                  v-model="coupon"
                  center
                  clearable
                  label="优惠码"
                  placeholder="请输入优惠码"
                  @clear="clearCoupon"
                  :disabled="checked ? true : false"
                >
                </van-field>
                <van-cell title=" ">
                  <template #right-icon>
                    <span style="margin-right: 10px">确认使用优惠码</span>
                    <van-checkbox
                      :disabled="coupon ? false : true"
                      @change="changeChecked"
                      v-model="checked"
                    />
                  </template>
                </van-cell>
                <van-cell title=" ">
                  <template #right-icon>
                    <span style="margin-right: 10px; color: green">{{
                      checked ? alertMessage_1 : ""
                    }}</span>
                  </template>
                </van-cell>
              </div>
              <div style="margin-top: 20px" @click="drawABill">
                <van-cell title="发票" is-link :value="invoiceWord" />
              </div>
              <div class="payMethods">
                <p style="margin-left: 20px">请选择支付方式</p>
                <van-radio-group v-model="radioPay">
                  <van-cell-group>
                    <van-cell clickable @click="radioPay = '1'">
                      <template #title>
                        <van-image width="30" height="30" :src="wxImg" />
                        <span class="custom-title">微信支付</span>
                      </template>
                      <template #right-icon>
                        <van-radio name="1" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
            </div>
          </div>
          <van-submit-bar
            :price="totalPrice"
            button-text="去支付"
            :loading="loadingFlag ? true : false"
            @submit="onSubmit('vips')"
          >
          </van-submit-bar>
          <div style="margin-top: 2rem"></div>
        </van-popup>
        <!-- VIP升级 一键上传 点击升级弹框 -->
        <van-popup
          v-model="showUpgrade"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '20px',
            }"
          >
            升级会员功能 体验更多特色功能
          </van-divider>
          <div class="upgradeItems">
            <div class="top-box">
              <div class="message">
                <div v-if="productcodeMenu == '000001'" class="left">
                  <p class="title">
                    {{ vipItemData.funcname
                    }}<span class="yigou">(已购：1)</span>
                  </p>
                  <p class="desc">
                    <van-tag plain color="#53514F" style="padding: 6px">{{
                      vipItemData.funcdesc
                    }}</van-tag>
                  </p>
                </div>
                <div v-else class="left">
                  <p class="title">
                    {{ vipItemData.funcname
                    }}<span class="yigou"
                      >(已购：{{ vipItemData.alreadybought }})</span
                    >
                  </p>
                  <p class="desc">
                    <van-tag plain color="#53514F">{{
                      vipItemData.funcdesc
                    }}</van-tag>
                  </p>
                </div>
                <div class="price">
                  &yen;<span>{{
                    (vipItemData.price * vipItemBuyDay * value) | toDecimal
                  }}</span>
                </div>
              </div>
              <div class="yearBox">
                <div v-if="productcodeMenu == '000001'" class="year">
                  剩余时长：{{ vipItemBuyDay }}天
                </div>
                <div v-else class="year">
                  <span
                    v-if="vipItemData.alreadybought >= vipItemData.maxactive"
                    >剩余时长：{{ vipItemBuyDay }}天</span
                  >
                  <span v-else>购买时长：{{ vipItemBuyDay }}天</span>
                </div>
                <div class="num">
                  购买数量：1
                </div>
              </div>
            </div>
          </div>
          <div v-if="accounttype == 1 || accounttype == 4">
            <van-goods-action v-if="productcodeMenu == '000001'">
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button type="info" text="已购买" disabled />
            </van-goods-action>
            <van-goods-action
              v-else-if="
                productcodeMenu != '000001' &&
                  vipItemData.alreadybought >= vipItemData.maxactive
              "
            >
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button type="info" text="已购买" disabled />
            </van-goods-action>
            <van-goods-action v-else>
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button
                color="#FFA71A"
                type="warning"
                text="加入购物车"
                @click="addToCart(2, vipItemData)"
              />
              <van-goods-action-button
                type="danger"
                text="立即购买"
                @click="buyNow('a')"
              />
            </van-goods-action>
          </div>
        </van-popup>
        <!-- 分屏权限 -->
        <van-popup
          v-model="showFpgrade"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '20px',
            }"
          >
            升级会员功能 体验更多特色功能
          </van-divider>
          <div class="upgradeItems">
            <div class="top-box">
              <div class="message">
                <div class="left">
                  <p class="title">
                    {{ vipItemData.funcname
                    }}<span class="yigou"
                      >(已购：{{ vipItemData.alreadybought }})</span
                    >
                  </p>
                  <p class="desc">
                    <van-tag plain color="#53514F" style="padding: 6px">{{
                      vipItemData.funcdesc + "(请在电脑端使用)。"
                    }}</van-tag>
                  </p>
                </div>
                <div class="price">
                  &yen;<span>{{
                    (vipItemData.price * vipItemBuyDay * numValueFp) | toDecimal
                  }}</span>
                </div>
              </div>
              <div class="yearBox">
                <div class="year">
                  <!-- 购买时长：{{ vipItemBuyDay }}天 -->
                  <span
                    v-if="vipItemData.alreadybought >= vipItemData.maxactive"
                    >剩余时长：{{ vipItemBuyDay }}天</span
                  >
                  <span v-else>购买时长：{{ vipItemBuyDay }}天</span>
                </div>
                <div class="num">
                  <van-stepper
                    v-model.number="numValueFp"
                    integer
                    :min="1"
                    :max="vipItemData.maxactive - vipItemData.alreadybought"
                    input-width="60px"
                    style="margin: auto"
                    :disabled="
                      vipItemData.alreadybought >= vipItemData.maxactive
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="accounttype == 1 || accounttype == 4">
            <van-goods-action
              v-if="vipItemData.alreadybought >= vipItemData.maxactive"
            >
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button type="info" text="已购买" disabled />
            </van-goods-action>
            <van-goods-action v-else>
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button
                color="#FFA71A"
                type="warning"
                text="加入购物车"
                @click="addToCart(3, vipItemData)"
              />
              <van-goods-action-button
                type="danger"
                text="立即购买"
                @click="buyNow('b')"
              />
            </van-goods-action>
          </div>
        </van-popup>
        <!-- 文件仓库 -->
        <van-popup
          v-model="showWjgrade"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '20px',
            }"
          >
            升级会员功能 体验更多特色功能
          </van-divider>
          <div class="upgradeItems">
            <div class="top-box">
              <div class="message">
                <div class="left">
                  <p class="title">
                    {{ vipItemData.funcname
                    }}<span class="yigou"
                      >(已购：{{ vipItemData.alreadybought }})</span
                    >
                  </p>
                  <p class="desc">
                    <van-tag plain color="#53514F">{{
                      vipItemData.funcdesc
                    }}</van-tag>
                  </p>
                </div>
                <div class="price">
                  &yen;<span>{{
                    (vipItemData.price * vipItemBuyDay * numValue) | toDecimal
                  }}</span>
                </div>
              </div>
              <div class="yearBox">
                <div class="year">
                  <!-- 购买时长：{{ vipItemBuyDay }}天 -->
                  <span
                    v-if="vipItemData.alreadybought >= vipItemData.maxactive"
                    >剩余时长：{{ vipItemBuyDay }}天</span
                  >
                  <span v-else>购买时长：{{ vipItemBuyDay }}天</span>
                </div>
                <div class="num">
                  <van-stepper
                    v-model.number="numValue"
                    integer
                    :min="1"
                    :max="vipItemData.maxactive - vipItemData.alreadybought"
                    input-width="60px"
                    style="margin: auto"
                    :disabled="
                      vipItemData.alreadybought >= vipItemData.maxactive
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="accounttype == 1 || accounttype == 4">
            <van-goods-action
              v-if="vipItemData.alreadybought >= vipItemData.maxactive"
            >
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button type="info" text="已购买" disabled />
            </van-goods-action>
            <van-goods-action v-else>
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button
                color="#FFA71A"
                type="warning"
                text="加入购物车"
                @click="addToCart(4, vipItemData)"
              />
              <van-goods-action-button
                type="danger"
                text="立即购买"
                @click="buyNow('c')"
              />
            </van-goods-action>
          </div>
        </van-popup>
        <!-- 云擎下载 -->
        <van-popup
          v-model="showVipgrade"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '20px',
            }"
          >
            升级会员功能 体验更多特色功能
          </van-divider>
          <div class="upgradeItems">
            <div class="top-box">
              <div class="message">
                <div class="left">
                  <p class="title">
                    {{ vipItemData.funcname
                    }}<span class="yigou"
                      >(已购：{{ vipItemData.alreadybought }})</span
                    >
                  </p>
                  <p class="desc">
                    <van-tag plain color="#53514F" style="padding: 6px">{{
                      vipItemData.funcdesc + "(请在电脑端使用。)"
                    }}</van-tag>
                  </p>
                </div>
                <div class="price">
                  &yen;<span>{{
                    (vipItemData.price * vipItemBuyDay * value) | toDecimal
                  }}</span>
                </div>
              </div>
              <div class="yearBox">
                <div class="year">
                  <!-- 购买时长：{{ vipItemBuyDay }}天 -->
                  <span
                    v-if="vipItemData.alreadybought >= vipItemData.maxactive"
                    >剩余时长：{{ vipItemBuyDay }}天</span
                  >
                  <span v-else>购买时长：{{ vipItemBuyDay }}天</span>
                </div>
                <div class="num">
                  购买数量：1
                </div>
              </div>
            </div>
          </div>
          <div v-if="accounttype == 1 || accounttype == 4">
            <van-goods-action
              v-if="vipItemData.alreadybought >= vipItemData.maxactive"
            >
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button type="info" text="已购买" disabled />
            </van-goods-action>
            <van-goods-action v-else>
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button
                color="#FFA71A"
                type="warning"
                text="加入购物车"
                @click="addToCart(5, vipItemData)"
              />
              <van-goods-action-button
                type="danger"
                text="立即购买"
                @click="buyNow('d')"
              />
            </van-goods-action>
          </div>
        </van-popup>
        <!-- 特定适用对象 -->
        <van-popup
          v-model="showWordSpetial"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '20px',
            }"
          >
            升级会员功能 体验更多特色功能
          </van-divider>
          <div class="upgradeItems">
            <div class="top-box">
              <div class="message">
                <div class="left">
                  <p class="title">
                    {{ vipItemData.funcname
                    }}<span class="yigou"
                      >(已购：{{ vipItemData.alreadybought }})</span
                    >
                  </p>
                  <p class="desc">
                    <van-tag plain color="#53514F" style="padding: 6px">{{
                      vipItemData.funcdesc
                    }}</van-tag>
                  </p>
                </div>
                <div class="price">
                  &yen;<span>{{
                    (vipItemData.price * vipItemBuyDay * value) | toDecimal
                  }}</span>
                </div>
              </div>
              <div class="yearBox">
                <div class="year">
                  <!-- 购买时长：{{ vipItemBuyDay }}天 -->
                  <span
                    v-if="vipItemData.alreadybought >= vipItemData.maxactive"
                    >剩余时长：{{ vipItemBuyDay }}天</span
                  >
                  <span v-else>购买时长：{{ vipItemBuyDay }}天</span>
                </div>
                <div class="num">
                  购买数量：1
                </div>
              </div>
            </div>
          </div>
          <div v-if="accounttype == 1 || accounttype == 4">
            <van-goods-action
              v-if="vipItemData.alreadybought >= vipItemData.maxactive"
            >
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button type="info" text="已购买" disabled />
            </van-goods-action>
            <van-goods-action v-else>
              <van-goods-action-icon
                icon="cart-o"
                text="购物车"
                :badge="shopCarBadge"
                @click="clickShopCar"
              />
              <van-goods-action-button
                color="#FFA71A"
                type="warning"
                text="加入购物车"
                @click="addToCart(6, vipItemData)"
              />
              <van-goods-action-button
                type="danger"
                text="立即购买"
                @click="buyNow('d')"
              />
            </van-goods-action>
          </div>
        </van-popup>

        <!-- 点击宫格里面的立即购买按钮后出现的弹框 -->
        <van-popup
          v-model="buyNowPopup"
          @close="closePopup"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <van-divider
            :style="{
              fontSize: '17px',
              marginTop: '40px',
              marginBottom: '10px',
            }"
          >
            购买升级包
          </van-divider>
          <div class="buyUpPackage">
            <div class="message">
              <h4>{{ vipItemData.funcname }}</h4>
              <div class="color">
                <div class="colorItem">
                  购买数量：
                  {{
                    vipItemData.funcname === "分屏权限"
                      ? numValueFp
                      : vipItemData.funcname === "文件仓库"
                      ? numValue
                      : value
                  }}
                </div>
                <div class="colorItem">购买时长：{{ vipItemBuyDay }}天</div>
              </div>
              <van-divider />
              <div class="discount">
                <div
                  class="discountItem"
                  v-for="item in discountdescdetail"
                  :key="item.discountdesc"
                >
                  <div class="discountItemW">{{ item.discountdesc }}</div>
                  <div class="discountItemW">
                    <span v-if="item.selected === false">未满足</span>
                    <van-radio v-if="item.selected === true"></van-radio>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px" v-if="isConpponma">
              <van-field
                v-model="coupon"
                center
                clearable
                label="优惠码"
                placeholder="请输入优惠码"
                @clear="clearCoupon"
                :disabled="checked ? true : false"
              >
              </van-field>
              <van-cell title=" ">
                <template #right-icon>
                  <span style="margin-right: 10px">确认使用优惠码</span>
                  <van-checkbox
                    :disabled="coupon ? false : true"
                    @change="changeChecked"
                    v-model="checked"
                  />
                </template>
              </van-cell>
              <van-cell title=" ">
                <template #right-icon>
                  <span style="margin-right: 10px; color: green">{{
                    checked ? alertMessage_1 : ""
                  }}</span>
                </template>
              </van-cell>
            </div>
            <div class="line"></div>
            <div style="margin-top: 20px" @click="drawABill">
              <van-cell title="发票" is-link :value="invoiceWord" />
            </div>
            <div class="payMethods">
              <p>请选择支付方式</p>
              <van-radio-group v-model="radioPay">
                <van-cell-group>
                  <van-cell clickable @click="radioPay = '1'">
                    <template #title>
                      <van-image width="30" height="30" :src="wxImg" />
                      <span class="custom-title">微信支付</span>
                    </template>
                    <template #right-icon>
                      <van-radio name="1" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </div>
          <van-submit-bar
            :price="totalPrice"
            button-text="去支付"
            :loading="loadingFlag ? true : false"
            @submit="onSubmit('vipitem')"
          >
          </van-submit-bar>
        </van-popup>
        <!-- 合同内容 用户协议 -->
        <van-popup
          v-model="userAgreement"
          @close="closePopup"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <div id="word_11"></div>

          <user-agreement-pop
            :userAgreementData="userAgreementData"
            :sumMoney="sumMoney"
          ></user-agreement-pop>
          <van-tabbar
            :border="false"
            style="
            background-color: #fff;
            diaplay: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
          "
          >
            <van-button
              style="height: 70%; width: 4rem"
              type="info"
              block
              round
              size="small"
              @click="agreePayMoney"
              >同意并确认支付</van-button
            >
            <van-button
              style="height: 70%; width: 100px; margin-left: 20px"
              type="default"
              block
              round
              size="small"
              @click="closePopup"
              >取消支付</van-button
            >
          </van-tabbar>
        </van-popup>
        <!-- VIP升级协议 -->
        <van-popup
          v-model="vipUpgradeAgreement"
          @close="closePopup"
          closeable
          close-icon="close"
          position="top"
          :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
        >
          <div id="word_22"></div>
          <VIPAgreementPop
            :userAgreementData="userAgreementData"
            :sumMoney="sumMoney"
          >
          </VIPAgreementPop>
          <van-tabbar
            :border="false"
            style="
            background-color: #fff;
            diaplay: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
          "
          >
            <van-button
              style="height: 70%; width: 4rem"
              type="info"
              block
              round
              size="small"
              @click="agreePayMoney"
              >同意并确认支付</van-button
            >
            <van-button
              style="height: 70%; width: 100px; margin-left: 20px"
              type="default"
              block
              round
              size="small"
              @click="closePopup"
              >取消支付</van-button
            >
          </van-tabbar>
        </van-popup>
        <!-- 开票弹框页面 -->
        <invoice-page
          ref="invoice"
          :totalPrice="totalPrice"
          @getInvoiceParams="getInvoiceParams"
        ></invoice-page>
      </template>
    </div>

  </div>
</template>

<script>
import TripleDES from "@/utils/lib/crypto.js";
import InvoicePage from "@/components/common/invoice";
import userAgreementPop from "@/components/newcommon/userAgreement";
import VIPAgreementPop from "@/components/newcommon/VIPAgreement";

import { wxpayFunc } from "@/utils/lib/wxpay.js";
import { searchToObj } from "@/utils/lib/searchtoobj.js";
import { getWxOpenIdUrl } from "../../../public/config.json";
import { errDialog, commonDialog, commonToast } from "@/utils/lib/toast.js";
import AcountLevel from "@/components/common/acountLevel";
import newOnlineMall from "@/components/newcommon/newonlinemall";
import { ISCONPPONMA } from "@/assets/js/gb.js";

export default {
  data() {
    return {
      checked: false,
      loadingFlag: false,
      dataForm: "", // 跳转地址
      userAgreement: false, // 用户协议
      vipUpgradeAgreement: false, // VIP升级协议
      userAgreementData: {}, // 合同返回得内容
      sumMoney: 0, // 合同中的合计
      invoiceData: {
        // 发票弹框的内容
        invoicetype: 1,
        invoiceheader: {
          headertype: 1,
          headername: "个人",
          headercode: "",
          officeaddress: "",
          mobilenumber: "",
          bankname: "",
          bankaccount: "",
        },
      },
      invoiceWord: "普通发票 个人",
      coupon: "", // 优惠卷
      couponItem: {}, // 优惠卷返回的数据
      agentCode: "", // 运营商编码
      agentCodeItem: {}, // 运营商编码返回的数据
      active: 0, // tab切换
      show: false, // 购买版本 立即购买商品弹框
      showPayEnd: false, // 支付成功弹框
      showUpgrade: false, // 升级弹框 一键上传
      showFpgrade: false, // 分屏权限
      showWjgrade: false, // 文件仓库
      showVipgrade: false, // 云擎下载
      showWordSpetial: false, // 特定适用对象
      // showPreferentialTaxation: false, // 税收优惠检索
      // showPreferentialTreaty: false, // 条约检索
      buyNowPopup: false, // 立即购买弹框
      vipDisabled: true, // 购买版本后可选择VIP升级
      radio: "1",
      goodsLists: [], //  商品列表数据
      effectiveorders: [{ productcode: "0" }], // 有效的产品订单
      freezeorders: [], // 冻结期订单
      buyItem: {}, // 点击购买的项
      gridItems: [], // vip升级得四个item
      img11: require("../../assets/shop/11.png"),
      img22: require("../../assets/shop/22.png"),
      img33: require("../../assets/shop/33.png"),
      img44: require("../../assets/shop/44.png"),
      img55: require("../../assets/shop/tedingduixiang.png"),
      img66: require("../../assets/shop/youhuizhengce.png"),
      img77: require("../../assets/shop/tioayuejiansuo.png"),
      vipItemData: {}, // 点击vip升级中的每一项得内容
      productcodeMenu: "", // 主套餐的code
      productcodeMenuOrderId: "", // 订单id

      years: [], // 选择年份优惠价格
      year: {}, // 选中的年份
      currentYearIndex: 0, // 选中的年份
      radioPay: "1", // 1：微信     2：支付宝
      openShopCar: false, // 购物车
      shopCarBadge: 0, // 购物车中的商品数量
      numValue: 1, // 文件夹个数
      numValueFp: 1, // 分屏个数
      wxImg: require("../../assets/shop/wx.png"),
      zfbImg: require("../../assets/shop/zfb.png"),
      totalPrice: 0, // 总价 格式 0000
      totalMoney: 0, // 原价 格式 0.00
      totalPriceYou: 0,
      totalMoneyYou: 0,
      shopCarLists: [], // 购物车中的内容
      value: 1, // 固定数量1
      value5: 0, // 版本的时间选择
      option5: [
        { text: "一年", value: 0 },
        { text: "两年", value: 1 },
        { text: "三年", value: 2 },
      ],
      buyMenuCode: [], // 已购买商品的code
      dongjieCode: [], // 已冻结商品code
      vipItemBuyDay: 0,
      vipItemWords: "",
      oldPrice: 0, // 原价
      paramsData: {},
      discountdescdetail: [], // 优惠信息
      iconCouponFlag: false, // 优惠码的错误提示信息
      iconAgentCodeFlag: false, // 运营商编码的错误提示信息
      alertMessage: "", // 优惠码提示信息
      alertMessage_1: "", // 优惠码返回的优惠信息
      titleNameWord: "", // 商城页面 账号等级 提示信息
      browser: "", // 是什么浏览器
      wxpayObj: "", // 微信支付参数

      // 当前在售的产品
      nowProduct: null,
      // 当前在售的产品下标
      nowProductIndex: 0,

      // 是否有优惠码
      isConpponma: ISCONPPONMA,
      routerAgentCode: ''  // 新加
    };
  },
  components: {
    InvoicePage,
    AcountLevel,
    userAgreementPop,
    VIPAgreementPop,
    newOnlineMall,
  },
  computed: {
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId: {
      get() {
        return this.$store.state.user.userId;
      },
      set() {},
    },
    accountstatus() {
      return this.$store.state.user.accountstatus;
    },
    accounttype: {
      get() {
        return this.$store.state.user.accounttype;
      },
      set() {},
    },
    wxopenid: {
      get() {
        return this.$store.state.user.wxopenid;
      },
      set() {},
    },
    showmsg: {
      get() {
        return this.$store.state.user.showmsg;
      },
      set() {},
    },

    // 扫描二维码过来的
    locationAgentCode: {
      get() {
        return this.$store.state.search.locationAgentCode;
      },
      set(value) {
        this.$store.state.search.locationAgentCode = value;
      },
    },

    // 商城版本
    mallver() {
      return this.$store.state.user.mallver;
    },
  },
  created() {
    if (this.$route.query.agentcode) {
      this.routerAgentCode = this.$route.query.agentcode
      console.log('扫运营商二维码1111====>', this.agentCode)
      this.buyItem.code = '000004'
      this.createFile()
    }
    if (location.search.includes("code")) {
      // 微信授权过来的
      if (location.search.includes("agentcode")) {
        // 扫描运营商一键购买的
        let newObj = searchToObj(location.search);
        // let agentcode = 111;
        let agentcode = newObj.agentcode;

        // 运营商过来的 没得优惠码
        this.isConpponma = false;

        this.$store.commit("search/setLocationAgentCode", agentcode);
        sessionStorage.setItem("agentcode", agentcode);

        console.log("agentcode===>", this.locationAgentCode);
        this.arriveByAgentCode(agentcode);
      } else if (!sessionStorage.getItem("wxopenid")) {
        // 用户账号密码过来的
        let newObj = searchToObj(location.search);
        this.arriveByWxUserBuy(newObj);
      } else {
        //
        this.getProductList();
      }
    } else if (
     sessionStorage.getItem("userId") &&
      !sessionStorage.getItem("wxopenid") &&
      Number(localStorage.getItem("WX_VERSION")) === 1
    ) {
      // 账号登录的
      // 没有微信授权  让微信授权
      console.log("没有微信授权  让微信授权");
      this.$http
        .reqPostGetWeixinPromise({
          http_redirct: getWxOpenIdUrl,
        })
        .then((res) => {
          location.href = res.item.url;
        })
        .catch((err) => {
          console.log("用户微信内账号登录获取权限", err);
        });
    } else if (
     sessionStorage.getItem("userId") &&
      !sessionStorage.getItem("wxopenid") &&
      Number(localStorage.getItem("WX_VERSION")) === 0
    ) {
      // 用户账号密码登录在非微信浏览器进来的
      this.titleNameWord = this.titleName();
      this.getProductList();
    } else {
      // 用户账号密码关联了微信
      this.titleNameWord = this.titleName();
      this.getProductList();
    }
  },

  methods: {
    //创建文件夹
    createFile () {
      this.$http.reqCreateDefault().then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            this.getFixedFolder()
          }
        }
      })
    },
    
    // 获取云端固定文件夹
    getFixedFolder() {
      this.$http.reqGetFixedFolder().then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            this.$store.dispatch(
              "fixedFolder/updateFixedFolderArr",
              response.item
            );
            localStorage.setItem(
              "fixedFolderArr",
              JSON.stringify(response.item)
            );
          }
        }
      });
    },
    // 商城页面 账号等级 提示信息
    titleName() {
      //console.log("this.accountstatus == 400", this.accounttype,this.accountstatus);
      if (this.accounttype == 4) {
        return "系统已匹配出您可以续购的账号等级";
      } else if (this.accounttype == 2 || this.accounttype == 3) {
        return "请与单位管理员联系";
      } else if (this.accountstatus == 200 || this.accountstatus == 207) {
        return "持续续费，尊享账号等级配置权益";
      } else if (
        this.accountstatus == 100 ||
        this.accountstatus == 107 ||
        this.accountstatus == 300 ||
        this.accountstatus == 400
      ) {
        return "购买账号等级，尊享账号等级配置权益";
      }
    },
    // 优惠码清除按钮
    clearCoupon() {
      this.checked = false;
    },
    changeChecked(name) {
      if (name == true) {
        this.caleCouponCodeAndAgentCode();
      } else {
        this.totalMoney = this.totalMoneyYou;
        this.totalPrice = this.totalPriceYou;
        this.alertMessage_1 = "";
      }
    },
    // 主产品续费按钮
    xuFeiBtn() {
      if (
        !sessionStorage.getItem("wxopenid") &&
        Number(localStorage.getItem("WX_VERSION"))
      ) {
        this.$http
          .reqPostGetWeixinPromise({
            http_redirct: getWxOpenIdUrl,
          })
          .then((res) => {
            //console.log("用户微信内登录点击确认支付按钮", res);
            location.href = res.item.url;
          })
          .catch((err) => {
            console.log("用户微信内登录点击确认支付按钮", err);
          });
      }
      this.$router.push("xuFeiPage");
    },
    // 关闭弹框 初始化数据
    closePopup() {
      if (location.search.includes("agentcode")) {
        this.show = true;
        errDialog("您还没购买产品，是否退出？", this, "是", "否", () => {
          //这个可以关闭安卓系统的手机
          document.addEventListener(
            "WeixinJSBridgeReady",
            function() {
              // eslint-disable-next-line no-undef
              WeixinJSBridge.call("closeWindow");
            },
            false
          );
          //这个可以关闭ios系统的手机
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call("closeWindow");
        });
      } else {
        this.coupon = "";
        this.agentCode = "";
        this.sumMoney = 0;
        this.userAgreement = false;
        this.vipUpgradeAgreement = false;
        this.iconCouponFlag = false;
        this.iconAgentCodeFlag = false;
        this.loadingFlag = false;
        this.checked = false;
        this.totalMoney = this.totalMoneyYou;
        this.totalPrice = this.totalPriceYou;
        this.buyNowPopup = false;
        this.openShopCar = false;
      }
    },
    // 第一次获取已开发票的内容
    firstGetInvoiceParams() {
      this.$http
        .getInvoiceHeader()
        .then((res) => {
          console.log("发票弹框按钮res===>", res);
          if (res.rtncode === 1 && res.rltcode === 1 && res.item != null) {
            if (res.item.headertype === 1) {
              // 个人
              this.invoiceWord = "普通发票 个人";
              this.invoiceData.invoiceheader = res.item;
            } else if (res.item.headertype === 2) {
              // 公司
              this.invoiceWord = "普通发票 公司";
              this.invoiceData.invoiceheader = res.item;
            }
            this.$refs.invoice.inputMsg(res.item);
          } else {
            this.invoiceWord = "普通发票 个人";
            this.$refs.invoice.inputMsg(this.invoiceData);
          }
        })
        .catch((err) => {
          console.log("开发票", err);
        });
    },
    // 获取发票弹框的内容
    getInvoiceParams(params, word) {
      this.invoiceData = params;
      this.invoiceWord = word;
    },
    // 发票
    drawABill() {
      this.$refs.invoice.openpopup();
      this.$refs.invoice.getTotalMoney(this.totalMoney);
    },
    // 重新获取权限
    getPremission() {
      this.$http
        .reqGetPremission()
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              let cookieData = TripleDES.decode(
                "token",
                JSON.parse(this.$cookie.get("cookieObj"))
              );
              let cookieObj = {
                userId: cookieData.userId,
                userguid: cookieData.userguid,
                realname: cookieData.realname,
                token: cookieData.token,
                accounttype: cookieData.accounttype,
                phone: cookieData.phone,
                permission: res.items,
              };
              let data = TripleDES.encode("token", cookieObj);
              this.$cookie.set("cookieObj", JSON.stringify(data), 4);
            }
          }
        })
        .catch((err) => {
          console.log("1111111服务器开小差啦,请刷新后重试!", err);
        });
    },
    // 点击订单类型
    choseMenu(code) {
      this.shopCarLists = []; // 切换时清空购物车中的内容
      this.shopCarBadge = 0;
      this.productcodeMenuOrderId = code;
      this.effectiveorders.forEach((item) => {
        if (item.orderid === code) {
          this.productcodeMenu = item.productcode;
        }
      });

      this.getExtFunctionList(
        this.productcodeMenu,
        this.productcodeMenuOrderId
      );
    },
    // 切换tab菜单  获取扩展功能包
    changeVanTabs(name) {
      this.titleNameWord = this.titleName();
      console.log("name, title", name);

      if (this.userId) {
        if (name === 1) {
          if (this.accounttype == 3 || this.accounttype == 2) {
            this.titleNameWord = "请与单位管理员联系";
          } else {
            this.titleNameWord = "升级VIP权限，体验更多惊喜";
          }

          this.productcodeMenu = this.effectiveorders[0].productcode; // 产品code
          this.productcodeMenuOrderId = this.effectiveorders[0].orderid; // 订单code

          this.getExtFunctionList(
            this.effectiveorders[0].productcode,
            this.effectiveorders[0].orderid
          );
          this.$nextTick(() => {
            this.active = 1;
          });
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },
    // 获取扩展功能包
    getExtFunctionList(code, orderid) {
      this.productcodeMenu = code;
      this.$http
        .reqGetExtFunctionList(code, orderid)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.gridItems = res.items.funcs; // vip宫格内容
              this.discountdescdetail = res.items.discountdescdetail; // 优惠信息
              this.vipItemBuyDay = res.items.days; // 天数
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取商品列表
    getProductList(data) {
      if (this.mallver != "v1") {
        this.$http.reqGetNewProductLists().then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              if (data === "二维码" && res.data.effectiveorders.length > 0) {
                // 已经有会员等级，让他到首页
                sessionStorage.clear();
                this.$cookie.delete();
                this.$router.push("/index");
              } else if (
                data === "二维码" &&
                (this.accounttype == 80 || sessionStorage.getItem("agentcode"))
              ) {
                // 自己选择购买等级
                // let buynowitem;
                // res.data.products.some(
                //   (item) => item.sequence == 3 && (buynowitem = item)
                // );
                // console.log(buynowitem);
                // this.$refs.newOmlineMallComponent.buyNow(buynowitem);
              }
              this.goodsLists = res.data.products;
              this.goodsLists.reverse()
              this.$refs.newOmlineMallComponent.clickCard(0, this.goodsLists[0])
            }
          }
        });
      } else {
        this.$http
          .reqGetProductLists()
          .then((res) => {

            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                if (data === "二维码" && res.data.effectiveorders.length > 0) {
                  // 已经有会员等级，让他到首页
                  sessionStorage.clear();
                  this.$cookie.delete();
                  this.$router.push("/index");
                } else if (
                  data === "二维码" &&
                  (this.accounttype == 80 ||
                    sessionStorage.getItem("agentcode"))
                ) {
                  // 找到当前在售的产品
                  this.nowProductIndex = res.data.products.findIndex(
                    (item) => item.sequence == 3
                  );
                  this.nowProduct = res.data.products[this.nowProductIndex];

                }

                this.goodsLists = res.data.products;
                this.goodsLists.reverse()
                this.$refs.newOmlineMallComponent.clickCard(0, this.goodsLists[0])
                this.effectiveorders = res.data.effectiveorders;
                this.freezeorders =
                  res.data.freezeorders != null ? res.data.freezeorders : [];
                if (this.effectiveorders.length > 0) {
                  this.vipDisabled = false;
                }
                this.effectiveorders.forEach((item) => {
                  this.buyMenuCode.push(item.productcode);
                });
                this.freezeorders.forEach((item) => {
                  console.log("冻结期item====》》", item);
                  this.dongjieCode.push(item.productcode);
                });

                if (this.accounttype == 3) {
                  this.changeVanTabs(1);
                }
              } else {
                commonToast(res.rltdesc, this);
              }
            } else {
              commonToast(res.rtndesc, this);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 判断立即购买和续费
    changeMenuBuy(code) {
      return this.buyMenuCode.includes(code);
    },
    // 判断冻结
    changeDongjie(code) {
      return this.dongjieCode.includes(code);
    },
    // 计算总价
    countTotalPrice() {
      let extfunc = [];
      this.shopCarLists.forEach((item) => {
        if (item.num >= item.maxactive - item.alreadybought) {
          item.num = item.maxactive - item.alreadybought;
        }
        extfunc.push({
          func_code: item.funccode,
          func_name: item.funcname,
          number: item.num,
        });
      });
      this.checkFunOrderDiscount(extfunc);
    },
    // 点击购物车
    clickShopCar() {
      this.openShopCar = true;
      if (this.shopCarLists.length === 0) {
        this.oldPrice = 0;
        this.totalPrice = 0;
      } else {
        this.firstGetInvoiceParams(); // 获取发票
        this.countTotalPrice();
      }
    },
    // 年份切换
    changeYear(year, index) {
      this.currentYearIndex = index;
      this.year = year;
      this.oldPrice = Number(year.oriprice); // 原价
      this.totalMoney = Number(year.newprice);
      this.totalPrice = Number(year.newprice) * 100;

      this.totalMoneyYou = Number(year.newprice);
      this.totalPriceYou = Number(year.newprice) * 100;

      this.caleCouponCodeAndAgentCode();
    },
    // 购物车中的删除按钮
    delItem(item, index) {
      this.shopCarLists.splice(index, 1); // 删除选中项
      this.countTotalPrice();
      this.shopCarBadge = this.shopCarLists.length; // 购物车徽标
      if (this.shopCarLists.length === 0) {
        this.totalPrice = 0;
      }
    },
    // 立即购买
    async buyNow(type, good, index) {
      if (this.locationAgentCode !== "") {
        this.agentCode = this.locationAgentCode;
        this.checked = true;
        await this.caleCouponCodeAndAgentCode();
      }

     
      if (good !== undefined && good.code === "000001") {
        this.isConpponma = false;
      }
      this.showUpgrade = false; // 一键上传
      this.showFpgrade = false; // 分屏权限
      this.showWjgrade = false; // 文件仓库
      this.showVipgrade = false; // 云擎下载
      this.showWordSpetial = false; // 特定适用对象
      this.showPreferentialTaxation = false; // 税收优惠检索
      this.showPreferentialTreaty = false;
      if (this.userId) {
        await this.firstGetInvoiceParams(); // 获取发票
        if (type === "edition") {
          this.buyItem = good;
          this.currentYearIndex = 0;
          this.totalPrice = Number(good.pricedesc) * 100;

          // 获取产品优惠列表
          this.$http
            .reqGetProductDiscount(good.code)
            .then((res) => {
              if (res.rtncode === 1) {
                if (res.rltcode === 1) {
                  this.show = true;
                  this.years = res.item;
                  this.year = res.item[0];
                  this.oldPrice = Number(this.year.oriprice); // 原价
                  this.totalMoney = Number(this.year.newprice);
                  this.totalPrice = Number(this.year.newprice) * 100;
                  this.totalMoneyYou = Number(this.year.newprice);
                  this.totalPriceYou = Number(this.year.newprice) * 100;
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (type === "all") {
          // 购物车中所有商品立即购买
          console.log("购物车中所有商品立即购买");
          this.clickShopCar();
        } else if (type === "a") {
          this.getVipItemData(1);
          this.buyNowPopup = true;
        } else if (type === "b") {
          this.getVipItemData(this.numValueFp);
          this.buyNowPopup = true;
        } else if (type === "c") {
          this.getVipItemData(this.numValue);
          this.buyNowPopup = true;
        } else if (type === "d") {
          this.getVipItemData(1);
          this.buyNowPopup = true;
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },

    // 加入购物车
    addToCart(num, good) {
      console.log("点击了加入购物车", num, good);
      if (this.userId) {
        if (num === 2) {
          // 一键上传
          let goodIndex = this.shopCarLists.findIndex(
            (good) => good.funccode === "000009"
          );
          if (goodIndex === -1) {
            // goodIndex为-1表示不存在, 要加入商品
            this.vipItemData.num = this.value;
            this.shopCarLists.push(this.vipItemData);
            this.shopCarBadge++;
          }
        } else if (num === 3) {
          // 分屏权限
          let goodIndex = this.shopCarLists.findIndex(
            (good) => good.funccode === "000011"
          );
          if (goodIndex === -1) {
            this.vipItemData.num = this.numValueFp;
            this.shopCarLists.push(this.vipItemData);
            this.shopCarBadge++;
          } else {
            // goodIndex存在, 更新数据
            this.shopCarLists[goodIndex].num =
              this.shopCarLists[goodIndex].num + this.numValueFp;
          }
        } else if (num === 4) {
          // 文件仓库
          let goodIndex = this.shopCarLists.findIndex(
            (good) => good.funccode === "000012"
          );
          if (goodIndex === -1) {
            this.vipItemData.num = this.numValue;
            this.shopCarLists.push(this.vipItemData);
            this.shopCarBadge++;
          } else {
            // goodIndex存在, 更新数据
            this.shopCarLists[goodIndex].num =
              this.shopCarLists[goodIndex].num + this.numValue;
          }
        } else if (num === 5) {
          // 云擎下载
          let goodIndex = this.shopCarLists.findIndex(
            (good) => good.funccode === "000010"
          );
          if (goodIndex === -1) {
            //goodIndex为-1表示不存在, 要加入商品
            this.vipItemData.num = this.value;
            this.shopCarLists.push(this.vipItemData);
            this.shopCarBadge++;
          }
        } else if (num === 6) {
          // 特定适用对象
          let goodIndex = this.shopCarLists.includes(good);
          console.log(goodIndex);
          if (!goodIndex) {
            //goodIndex为false表示不存在, 要加入商品
            this.vipItemData.num = this.value;
            this.shopCarLists.push(this.vipItemData);
            this.shopCarBadge++;
          }
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },
    // 购物车中的输入框改变事件
    inputChange() {
      this.countTotalPrice();
    },
    // 主套餐 确认支付
    confirmPayment() {
      console.log("点击主菜单的去支付按钮", this.accounttype);
      /*  if (this.accounttype == 80) {
        this.$dialog
          .confirm({
            message: "您还未注册，请先注册后在购买，是否注册？",
            confirmButtonText: "是",
            cancelButtonText: "否",
          })
          .then(() => {
            let wxRegLoginObj = JSON.parse(
              sessionStorage.getItem("wxPromiseObj")
            );
            wxRegLoginObj.tempuserguid = localStoragegetItem("userguid");
            console.log(wxRegLoginObj);

            this.$http
              .reqPostWeixinRegLogin(wxRegLoginObj)
              .then((res) => {
                console.log("微信支付注册===>", res);
                if (res.rtncode == 1) {
                  if (res.rltcode == 1) {
                    this.bus.$emit("saveTokenHandle", res);
                  }
                }
              })
              .catch((err) => {
                console.log("微信支付注册===>", err);
              });
          })
          .catch((err) => {
            console.log("点击了去支付的否===>", err);
          });

        return;
      } */
      if (this.isConpponma) {
        if (!this.checked) {
          this.alertDialog_1(
            "您没有确认使用优惠码和运营商编码，是否继续下单？"
          );
        } else {

          if (
            this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            !this.agentCode
          ) {
            this.alertDialog_1("您没有填写运营商编码，是否继续下单？");
          } else if (
            this.iconCouponFlag &&
            !this.iconAgentCodeFlag &&
            this.agentCode &&
            !this.coupon
          ) {
            this.alertDialog_1(
              `您没有填写优惠码且${this.alertMessage}，是否继续下单？`
            );
          } else if (
            !this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            !this.agentCode
          ) {
            this.alertDialog_1(
              `您没有填写运营商编码且${this.alertMessage}，是否继续下单？`
            );
          } else if (
            !this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
          } else if (
            this.iconCouponFlag &&
            !this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
          } else if (
            !this.iconCouponFlag &&
            !this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
          } else if (
            this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            this.coupon &&
            this.agentCode
          ) {
            this.onConfirm_1();
          } else if (
            this.iconCouponFlag &&
            this.iconAgentCodeFlag &&
            !this.coupon &&
            this.agentCode
          ) {
            this.alertDialog_1(`您还没有选择优惠码，是否继续下单？`);
          }
        }
      } else {
        if (!this.checked) {
          this.alertDialog_1("您没有确认使用运营商编码，是否继续下单？");
        } else {
          this.onConfirm_1();
        }
      }
    },
    // 提示信息弹框
    alertDialog_1(message) {
      this.$dialog
        .confirm({
          title: "提示",
          message: message,
          confirmButtonText: "下单",
        })
        .then(() => {
          // on confirm
          this.onConfirm_1();
        })
        .catch(() => {
          // on cancel
        });
    },
    onConfirm_1() {
      this.loadingFlag = true;
      if (this.radioPay == "1") {
        this.isWeixin();
      } else if (this.radioPay === "2") {
        console.log("支付宝支付");
      }
    },
    // 计算优惠码和运营商编码优惠信息
    caleCouponCodeAndAgentCode() {
      if (this.checked) {
        let params = {
          amount: this.totalMoney,
          couponcode: this.coupon,
          agentcode: this.agentCode || this.locationAgentCode,
        };
        this.$http
          .reqCaleCouponCodeAndAgentCode(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                if (res.item.couponrlt && res.item.agentrlt) {
                  this.iconCouponFlag = true;
                  this.iconAgentCodeFlag = true;
                  this.totalMoney = res.item.amount;
                  this.totalPrice = res.item.amount * 100; // 折后价
                  this.alertMessage_1 = res.item.discountdesc;
                } else if (!res.item.couponrlt && res.item.agentrlt) {
                  this.iconCouponFlag = false;
                  this.iconAgentCodeFlag = true;
                  this.alertMessage = res.item.couponrltdesc;
                  this.alertMessage_1 = res.item.discountdesc;
                } else if (res.item.couponrlt && !res.item.agentrlt) {
                  this.iconCouponFlag = true;
                  this.iconAgentCodeFlag = false;
                  this.alertMessage = res.item.agentrltdesc;
                  this.alertMessage_1 = res.item.discountdesc;
                } else if (!res.item.couponrlt && !res.item.agentrlt) {
                  this.iconCouponFlag = false;
                  this.iconAgentCodeFlag = false;
                  this.alertMessage = `${res.item.couponrltdesc}，${res.item.agentrltdesc}`;
                  this.alertMessage_1 = res.item.discountdesc;
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 主套餐支付
    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("是微信浏览器", this.totalPrice / 100);
        this.browser = "wx";

        let params = {
          product: this.buyItem.code, // 购买的产品
          discount: this.year.discountcode, // 选择的优惠方式
          paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付  32微信内支付
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.iconAgentCodeFlag ? this.agentCode : "", // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
          wxopenid: sessionStorage.getItem("wxopenid"),
        };

        this.$http
          .reqPostProduceOrder(params)
          .then((res) => {
            //console.log("微信内套餐支付返回参数res===>", res);
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.wxpayObj = JSON.parse(res.result.strdata);
                this.getUserAgreement(res.result.orderid, "main");
                // this.userAgreement = true;
              } else {
                commonToast(res.rltdesc, this);
                this.loadingFlag = false;
              }
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          })
          .catch((err) => {
            console.log(err);
            // this.$toast("微信内主套餐支付服务器开小差啦,请刷新后重试!");
          });
      } else {
        console.log("非微信浏览器this.year", this.year);
        let params = {
          product: this.buyItem.code, // 购买的产品
          discount: this.year.discountcode, // 选择的优惠方式
          paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.iconAgentCodeFlag ? this.agentCode : "", // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
        };
        this.$http
          .reqPostProduceOrder(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.dataForm = res.result.strdata;
                this.getUserAgreement(res.result.orderid, "main");
              } else {
                commonToast(res.rltdesc, this);
                this.loadingFlag = false;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // vip升级支付
    isWeixinItem(extfunc) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.browser = "wx";
        console.log("是微信浏览器", this.totalPrice / 100);

        let params = {
          productcode: this.productcodeMenu,
          productorderid: this.productcodeMenuOrderId,
          paytype: 32,
          extfunc: extfunc,
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.iconAgentCodeFlag ? this.agentCode : "", // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
          wxopenid: sessionStorage.getItem("wxopenid"),
        };
        this.$http
          .reqPostFunctionOrder(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.wxpayObj = JSON.parse(res.result.strdata);
                this.getUserAgreement(res.result.orderid, "vips");
              } else {
                commonToast(res.rltdesc, this);
                this.loadingFlag = false;
              }
            }
          })
          .catch((err) => {
            this.loadingFlag = false;
          });
      } else {
        let params = {
          productcode: this.productcodeMenu,
          productorderid: this.productcodeMenuOrderId,
          paytype: 31,
          extfunc: extfunc,
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.iconAgentCodeFlag ? this.agentCode : "", // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
        };
        this.$http
          .reqPostFunctionOrder(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.dataForm = res.result.strdata;
                this.getUserAgreement(res.result.orderid, "vips");
              } else {
                commonToast(res.rltdesc, this);
              }
            }
          })
          .catch((err) => {
            this.loadingFlag = false;
          });
      }
    },
    // 获取用户协议的内容
    getUserAgreement(orderid, type) {
      console.log("orderid, type", orderid, type);
      this.$http
        .reqGetContractinfo(orderid)
        .then((res) => {
          if (res.rtncode === 1 && res.rltcode === 1) {
            this.userAgreementData = res.item;
            this.userAgreementData.detail.forEach((item) => {
              this.sumMoney += item.amount;
            });
            if (type == "main") {
              if (this.browser) {
                this.userAgreement = true;
              } else {
                this.userAgreement = true;
                this.$nextTick(() => {
                  let dom = document.getElementById("word_11");
                  dom.scrollIntoView();
                });
              }
            } else if (type == "vips") {
              if (this.wxpayObj) {
                this.vipUpgradeAgreement = true;
              } else {
                this.vipUpgradeAgreement = true;
                this.$nextTick(() => {
                  let dom = document.getElementById("word_22");
                  dom.scrollIntoView();
                });
              }
            }
          } else {
            console.log("获取用户协议的内容err===>", res.rltdesc);
          }
        })
        .catch((err) => {
          console.log("获取用户协议服务器开小差啦,请刷新后重试!", err);
        });
    },
    // 同意并确认支付
    agreePayMoney() {
      if (Number(localStorage.getItem("WX_VERSION"))) {
        if (this.wxpayObj) {
          console.log("同意并确认支付是wx内", this.wxpayObj);
          wxpayFunc(this.wxpayObj, this.wxPayCallback);
        }
      } else {
        location.href = this.dataForm;
      }
    },
    // 验证扩展功能订单并计算优惠
    checkFunOrderDiscount(extfunc) {
      let params = {
        productcode: this.productcodeMenu,
        productorderid: this.productcodeMenuOrderId,
        paytype: 31,
        extfunc: extfunc,
      };
      this.$http
        .reqPostFunctionOrderAndCaleDiscount(params)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.oldPrice = res.result.orderamount; // 原价
              this.totalMoney = res.result.actualamount;
              this.totalPrice = res.result.actualamount * 100; // 折后价
              this.totalMoneyYou = res.result.actualamount;
              this.totalPriceYou = res.result.actualamount * 100;
              this.vipItemBuyDay = res.result.days; // 剩余天数 购买天数
              this.vipItemWords = res.result.discountdesc; // 优惠文字信息
              this.discountdescdetail = res.result.discountdescdetail; // 优惠信息
              this.caleCouponCodeAndAgentCode();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 购物车中提交订单
    onSubmit(type) {
      if (!this.checked) {
        this.alertDialog("您没有确认使用优惠码，是否继续下单？", type);
      } else {
        if (!this.iconCouponFlag) {
          this.alertDialog_1(`${this.alertMessage}，是否继续下单？`);
        } else if (this.iconCouponFlag) {
          this.onConfirm(type);
        }
      }
    },
    // 提示信息弹框
    alertDialog(message, type) {
      this.$dialog
        .confirm({
          title: "提示",
          message: message,
          confirmButtonText: "下单",
        })
        .then(() => {
          // on confirm
          this.onConfirm(type);
        })
        .catch(() => {
          // on cancel
        });
    },
    onConfirm(type) {
      this.loadingFlag = true;
      if (type === "main") {
        if (this.radioPay === "1") {
          this.isWeixin();
        } else if (this.radioPay === "2") {
          console.log("支付宝支付");
        }
      } else if (type === "vips") {
        if (this.radioPay === "1") {
          let extfunc = [];
          this.shopCarLists.forEach((item) => {
            extfunc.push({
              func_code: item.funccode,
              func_name: item.funcname,
              number: item.num,
            });
          });
          this.isWeixinItem(extfunc);
        } else if (this.radioPay === "2") {
          console.log("支付宝支付");
        }
      } else if (type === "vipitem") {
        // 提交扩展功能订单
        if (this.radioPay === "1") {
          let number =
            this.vipItemData.funcname === "文件仓库"
              ? this.numValue
              : this.vipItemData.funcname === "分屏权限"
              ? this.numValueFp
              : 1;
          let extfunc = [
            {
              func_code: this.vipItemData.funccode,
              func_name: this.vipItemData.funcname,
              number,
            },
          ];
          this.isWeixinItem(extfunc);
        } else if (this.radioPay === "2") {
          console.log("支付宝支付");
        }
      }
    },
    // 点击升级宫格
    clickUpgrade(item) {
      console.log("点击宫格item, index===>", item);
      this.vipItemData = item;
      if (item.funccode === "000009") {
        // 一键上传
        this.showUpgrade = true;
      } else if (item.funccode === "000011") {
        // 分屏权限
        this.showFpgrade = true;
        this.numValueFp = 1;
      } else if (item.funccode === "000012") {
        // 文件仓库
        this.showWjgrade = true;
        this.numValue = 1;
      } else if (item.funccode === "000010") {
        // 云擎下载
        this.showVipgrade = true;
      } else if (item.funccode === "000017") {
        // 特定适用对象
        this.showWordSpetial = true;
      } else if (item.funccode === "000004") {
        // 税收优惠检索
        this.showWordSpetial = true;
      } else if (item.funccode === "000005") {
        // 条约检索
        this.showWordSpetial = true;
      }
    },
    // 点击vip里面得立即购买 计算优惠后得价格
    getVipItemData(number) {
      let extfunc = [
        {
          func_code: this.vipItemData.funccode,
          func_name: this.vipItemData.funcname,
          number,
        },
      ];
      this.checkFunOrderDiscount(extfunc);
    },
    // 点击禁用的tab标签
    clickDisabledTab() {
      if (this.accounttype == 3) {
        commonToast("请与单位管理员联系", this);

        return;
      }
      commonToast("请先购买账号等级", this);
    },
    // 微信内支付回调函数
    wxPayCallback(res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        commonDialog(
          "支付成功，您可以使用微信登录众智云擎。",
          this,
          "确认",
          () => {
            console.log("支付成功了调dialog");
            this.loadingFlag = false;
            this.$http.refreshToken().then((res) => {
              this.bus.$emit("saveTokenHandle", res, 1);
              this.$router.push("/newFiles");
            });
          }
        );
        /* this.$dialog
          .alert({
            message: "支付成功!您可以使用微信登录众智云擎。",
          })
          .then(() => {
            console.log("支付成功了调dialog");
            this.loadingFlag = false;
            this.$http.refreshToken().then((res) => {
              this.bus.$emit("saveTokenHandle", res);
              this.$router.push("/newFiles");
            });
          }); */
      } else {
        this.$notify({
          type: "warning",
          message: "用户支付失败!",
          duration: 5000,
        });
        this.loadingFlag = false;
      }
    },
    // 扫描运营商二维码进入的
    arriveByAgentCode(agentcode) {
      this.agentCode = agentcode;

      this.getProductList("二维码");
    },
    // 微信内用户登录
    arriveByWxUserBuy(newObj) {
      this.$http
        .reqPostWeixinGetWxId(newObj)
        .then((res) => {
          sessionStorage.setItem("wxopenid", res.item.openid);
          this.$store.commit("user/setWxOpenId", res.item.openid);
          this.getProductList();
        })
        .catch((err) => {
          console.log("微信内用户登录返回====>", err);
        });
    },
  },
  watch: {
    productcodeMenu(newV, oldV) {
      if (newV === "000001") {
        this.isConpponma = false;
      } else {
        this.isConpponma = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#onlineMall {
  margin-bottom: 2.6rem;
  font-size: 14px;
  .userAgreementContent {
    padding: 0 10px;
    margin-bottom: 3rem;
    & > h4 {
      margin-bottom: 0;
    }
    .contentItemP {
      & > p {
        text-indent: 20px;
        margin: 0;
        margin-top: 4px;
      }
      & > h5 {
        margin: 0;
        margin-top: 4px;
      }
    }
    .marginT {
      margin-top: 20px;
    }
    .zhangStyle {
      position: relative;
      & > img {
        position: absolute;
        top: 42%;
        left: 28%;
      }
    }
  }
  .shopBox {
    margin: 10px 14px;
    .overthree {
      height: 86px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    .message {
      height: 150px;
      background-image: url(../../assets/shop/vipbg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      -webkit-background-size: 100% 100%;
      padding: 20px 20px 0px;
      box-sizing: border-box;
      .img {
        display: flex;
        .word {
          margin-left: 16px;
          color: #9e7b57;
          font-size: 14px;
          padding: 4px 0;
          box-sizing: border-box;
          .user {
            font-size: 16px;
            font-weight: bold;
            margin: 0 0 10px;
          }
          .time {
            margin-top: 6px;
          }
        }
      }
      .bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .word {
          color: #9e7b57;
          font-size: 14px;
        }
      }
    }
  }
  .shop-item {
    background: #fff;
    padding: 20px 10px;
    margin-bottom: 10px;
    position: relative;
    .sell {
      width: 40px;
      height: 40px;
      position: absolute;
      right: 0;
      top: 0;
      // &>img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .item-top {
      height: 50px;
      display: flex;
      .img {
        flex: 0 0 80px;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .money {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          font-size: 14px;
          font-weight: bold;
        }
        .yuan {
          color: #cb4649;
          font-size: 14px;
          font-weight: bold;
        }
        .year {
          font-size: 12px;
          color: #cb4649;
          margin-right: 6px;
        }
      }
    }
    .item-center {
      display: flex;
      margin-top: 16px;
      .word {
        flex: 0 0 40px;
        padding: 2px 0 0 2px;
      }
      .tag {
        flex: 1;
        /deep/.van-tag--plain::before {
          border: 0.02667rem solid #ddd !important;
          font-size: 12px;
        }
      }
    }
    .bar {
      display: flex;
      justify-content: flex-end;
      .word {
        width: 70px;
        font-size: 12px;
      }
      .progress {
        display: flex;
        align-items: center;
      }
    }
    .buyBtn {
      margin-top: 20px;
      .show,
      .notshow {
        div {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          &:before,
          &:after {
            content: "";
            display: block;
          }
        }
      }
    }
  }
  .payMethods {
    margin-bottom: 2.6rem;
    font-size: 14px;
    color: #656565;
    p {
      margin: 20px 0;
    }
    /deep/.van-cell__title {
      display: flex;
      align-items: center;
    }
    .custom-title {
      margin-left: 10px;
    }
  }
  .agree {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 2.6rem;
    a {
      color: @--primary-color;
    }
  }
  .bottom-line {
    border-bottom: 1px solid #efefef;
    padding-bottom: 16px;
  }
  .chooseYear {
    margin-top: 16px;
    display: flex;
    text-align: center;
    // justify-content: flex-start;
    justify-content: space-around;
    .one {
      border: 1px solid #f2f2f2;
      width: 30%;
      padding: 10px 0;
      border-radius: 6px;
      p {
        margin: 0;
      }
      .year {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 4px;
      }
      .yuan {
        margin-bottom: 4px;
        color: @--primary-color;
        .money {
          font-size: 18px;
          font-weight: bold;
        }
      }
      .yuanold {
        margin-bottom: 4px;
        font-size: 12px;
        color: #ccc;
      }
    }
    .yearActive {
      background-color: @--background-color;
      border: 1px solid #e5c693;
    }
  }
  .notActive {
    opacity: 0.5;
  }
  .van-tag {
    margin: 2px;
  }
  .line {
    width: 100%;
    height: 8px;
    margin: 14px 0;
    background: #f6f6f6;
  }
  // tab标签选中的颜色样式
  /deep/.van-tab {
    .van-tab__text {
      color: @--primary-color;
      padding: 6px 14px;
      border: 1px solid @--primary-color;
      border-radius: 20px;
    }
  }
  /deep/.van-tab--active {
    .van-tab__text {
      color: #fff;
      padding: 6px 14px;
      background-color: @--primary-color;
      border-radius: 20px;
    }
  }
  /deep/.van-cell--clickable:active {
    background-color: #fff;
  }
  /deep/.van-overlay {
    height: 20%;
  }
  /deep/.van-cell:not(:last-child)::after {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    top: 10;
  }
  .upgradeItems {
    .top-box {
      background-color: #fff;
      padding: 0px 20px;
      margin-bottom: 16px;
      .message {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.37333rem;
        padding: 10px 0;
        box-sizing: border-box;
        .img {
          flex: 0 0 60px;
        }
        .left {
          p {
            margin: 0;
            .yigou {
              color: green;
              margin-left: 20px;
            }
          }
          .title {
            color: #333;
            font-weight: bold;
          }
        }
        .price {
          margin: 0 4px;
          color: red;
          text-align: center;
          span {
            font-size: 16px;
            font-weight: bold;
            margin-left: 4px;
          }
        }
      }
      .yearBox {
        padding: 10px 0 12px 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        box-sizing: border-box;
        border-top: 1px solid #ccc;
        // .year {
        //   /deep/.van-ellipsis {
        //     color: #333;
        //     font-weight: 500;
        //   }
        //   /deep/.van-overlay {
        //     background-color: #fff;
        //   }
        //   /deep/.van-dropdown-menu__title::after {
        //     border-color: transparent transparent #333 #333
        //   }
        // }
      }
    }
  }
  .buyUpPackage {
    padding: 0 20px;
    box-sizing: border-box;
    .message {
      background: #fee5a7;
      padding: 10px;
      // box-sizing: border-box;
      & > h4 {
        color: red;
        margin: 0;
        text-align: center;
      }
      .color {
        color: #c57e00;
        text-align: center;
        .colorItem {
          margin-top: 10px;
        }
      }
      .discount {
        font-size: 12px;
        .discountItem {
          display: flex;
          justify-content: space-between;
          .discountItemW {
            margin-bottom: 10px;
            &:nth-child(1) {
              width: 76%;
            }
          }
        }
      }
    }
  }
  .vipImg {
    width: 50px;
    height: 50px;
  }
  .successIcon {
    font-size: 25px;
    position: absolute;
    right: 10px;
    top: 10px;
    color: #3ac89b;
  }
}
</style>
